import { Component, Inject, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CaseView } from '../../models/caseview.model';

@Component({
  selector: 'app-delete-intimations',
  templateUrl: './delete-intimations.component.html',
  styleUrls: ['./delete-intimations.component.scss'],
})
export class DeleteIntimationsComponent implements OnInit {
  @Input() caseData: CaseView[];
  docId: number;
  appTypeId: string;
  FinalData = [];
  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: CaseView[],
    public dialogRef: MatDialogRef<DeleteIntimationsComponent>
  ) {}

  ngOnInit(): void {
    console.log();
  }

  DeleteData(): void {
    console.log('delete');
    const options = {
      headers: {},
      body: [],
    };
    this.caseData = this.data;
    console.log(this.caseData);
    this.caseData.forEach((ele) => {
      this.docId = ele.docId;
      console.log(this.docId);
      options.body.push({
        intimationId: this.docId,
        appTypeId: '9',
      });
    });
    console.log(options);

    this.http.delete('/case-mgmnt/intimation', options).subscribe((s) => {
      this.dialogRef.close(true);
    });
  }
}
